import React, { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

interface UiLabelPlaceholderProps extends PropsWithChildren {
  variant?: "yellow" | "regular";
  unwrapped?: boolean;
}

export default function UiLabelPlaceholder({ children, variant = "regular", unwrapped = false }: UiLabelPlaceholderProps) {
  const value = children || "new";
  return unwrapped ? (
    value
  ) : (
    <span className={twMerge("cursor-default select-none font-sans text-[12px] uppercase leading-3 tracking-wide", variant === "yellow" ? "text-info-500" : "text-neutral-900")}>
      {value}
    </span>
  );
}
